import AOS from 'aos';
import Rellax from 'rellax';
import 'slick-carousel';
import {gsap} from 'gsap';
import {SplitText} from 'gsap/SplitText';
// import SplitType from 'split-type'

export default {
    init() {
        // JavaScript to be fired on all pages

        // $('.wp-block-cover:first h2').append('<span class="animate__animated animate__fadeInUp animate__delay-1s">' + $('.wp-block-cover h2').html() +'</span>');
        // $('.wp-block-cover:first p.lead').append('<span class="animate__animated animate__fadeInDown animate__delay-2s">' + $('.wp-block-cover p.lead').html() +'</span>');

        gsap.registerPlugin(SplitText);
        const text = new SplitText('body:not(.template-about) .cover-hero h2, body:not(.template-about) .cover-2col h2', {type: 'lines', linesClass: 'headline'});
        const aboutText = new SplitText('body.about .cover-2col h2', {type: 'lines, words', linesClass: 'headline', wordsClass: 'word'});
        var copy = $('.wp-block-cover:first p.lead:first');
        $('.headline, .wp-block-cover:first p.lead:first').wrap('<div class="wrapper"></div>');
        gsap.from(text.lines, {
            opacity: 0,
            y: 200,
            duration: 1.25,
            delay: 1.5,
            stagger: { amount: 1 },
        });
        gsap.from(copy, {
            opacity: 0,
            y: -50,
            duration: .75,
            delay: function (index, target) {
                if ($(target).hasClass('about')) {
                    return 5.5
                } else if ($(target).hasClass('contact')) {
                    return 4
                } else {
                    return 3
                }
            },
        });

        var lines = $('.headline').length;
        gsap.from(aboutText.lines, {
            opacity: 0,
            y: 200,
            duration: 1.25,
            delay: 1.5,
            stagger: function(index) {
                return (index - 2 % lines === 0 ? lines / 2 : index / 5);
            },
        });


        /* Hamburger Nav */
        $('#nav-toggle-check').change(function () {
            if (this.checked) {
                $('.menu-main-navigation-container').addClass('nav-open');
                $('header.banner').addClass('blurred');
                // Get the current page scroll position
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop,
                    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

                // if any scroll is attempted, set this to the previous value
                window.onscroll = function() {
                    window.scrollTo(scrollLeft, scrollTop);
                };
            } else {
                $('.menu-main-navigation-container').removeClass('nav-open');
                $('header.banner').removeClass('blurred');
                window.onscroll = function() {};
            }
        });

        $('.menu-main-navigation-container a').on('click', function () {
            $('#nav-toggle-check').prop('checked', false);
            $('.nav-primary').removeClass('nav-open');
        })

        document.querySelectorAll('a[href^="/#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();

                document.querySelector(this.getAttribute('href').substr(1)).scrollIntoView({
                    behavior: 'smooth',
                });
                document.getElementById('nav-menu').classList.remove('opened');
                document.getElementById('nav-toggle-check').checked = false;
            });
        });
        /* end Hamburger Nav */

        /* Header Hide */
        var lastScrollTop = 0;
        $(window).on('scroll', function(){
            var st = $(this).scrollTop();
            if (st > lastScrollTop) {
                if($(window).scrollTop() >= 300) {
                    $('body:not(.anchors):not(.team) header.banner').addClass('hide-header').addClass('backed');
                    $('body.anchors header.banner, body.team header.banner').addClass('backed');
                } else {
                    $('body:not(.anchors):not(.team) header.banner').removeClass('hide-header').removeClass('backed');
                    $('body.anchors header.banner, body.team header.banner').removeClass('backed');
                }
                if($(window).scrollTop() + $(window).height() > $(document).height() - $(document).height() / 10) {
                    $('header.banner').addClass('see-footer');
                } else {
                    $('header.banner').removeClass('see-footer');
                }
            } else {
                $('body header.banner').removeClass('hide-header').removeClass('see-footer');
            }
            lastScrollTop = st;

        })
        /* end Header Hide */
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        /* AOS */
        $('.cover-hero > div, .sticky-block .wp-block-group').attr({
            'data-aos' : 'fade-out',
            'data-aos-anchor-placement' : 'bottom-center',
        });
        // $('.page:not(.home) main .anchor').attr({
        //     'data-aos' : 'fade-out',
        //     'data-aos-anchor-placement' : 'bottom-top',
        //     'data-aos-delay' : 500,
        // });
        AOS.init();
        /* end AOS */

        new Rellax('.rellax');

        /* Element Viewport Focus */
        let mainBackground = $('.duo-background').attr('data-image-url');
        $('.duo-background').css('background-image', 'url("' + mainBackground + '")');

        /* non-blocks */
        // $('.page main.main > :not([class^="wp-block-"])').wrap('<div class="container"></div>');
        /* end non-blocks */

        /* Page Transitions */
        setTimeout(function(){
            $('#page-transition').removeClass('enter');
        },500);

        $('li.current-menu-item a').each(function(){
            var thisHash = $(this).attr('href');
            if (thisHash.split('#')[1]) {
                $(this).attr('href', '#' + thisHash.split('#')[1]);
                $(this).addClass('local');
            }
        })

        var siteURL = top.location.host.toString(),
            siteLinks = $(
                'a:not(.local)[href^="http://' + siteURL + '"], ' +
                'a:not(.local)[href^="https://' + siteURL + '"], ' +
                'a:not(.local)[href^="/"], a[href^="./"], a[href^="../"]'
            );

        siteLinks.click(function(evt){
            evt.preventDefault();
            var link = $(this).attr('href');
            $('#page-transition').addClass('exit');
            $('.current-menu-item').addClass('blur');
            setTimeout(function() {
                $('#page-transition').addClass('enter');
                window.location.href = link;
            }, 750);
        });

        const perfEntries = performance.getEntriesByType('navigation');
        if (perfEntries.length && perfEntries[0].type === 'back_forward') {
            console.log('welcome back!');
            $('#page-transition').removeClass('enter').removeClass('exit');
        }
        /* end Page Transitions */

        /* Slick */

        /* end Slick */

        $('#boss-button').dblclick(function(){
            window.open('https://vimeo.com/156947207');
        })
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js